function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("title", null, "FF3447F2-BD18-475D-8705-0715806BF94B@1.00x");

var _ref3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
  d: "M15.931,20.28 C25.359,20.28 28.651,24.33 28.786,24.502 C28.925,24.678 29,24.896 29,25.12 L29,28 C29,28.552 28.552,29 28,29 L4,29 C3.448,29 3,28.552 3,28 L3,25.12 C3,24.904 3.07,24.693 3.2,24.52 C3.33,24.347 6.489,20.28 15.931,20.28 Z M15.931,22.28 C8.839,22.28 5.775,24.748 5,25.508 L5,27 L27,27 L27,25.519 C26.197,24.757 23.035,22.28 15.931,22.28 Z M16,3 C20.135,3 23.5,6.365 23.5,10.5 C23.5,14.635 20.135,18 16,18 C11.865,18 8.5,14.635 8.5,10.5 C8.5,6.365 11.865,3 16,3 Z M16,5 C12.967,5 10.5,7.467 10.5,10.5 C10.5,13.533 12.967,16 16,16 C19.033,16 21.5,13.533 21.5,10.5 C21.5,7.467 19.033,5 16,5 Z",
  id: "path-1"
}));

var _ref4 = /*#__PURE__*/React.createElement("g", {
  id: "Documentation-Icons",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "Documentation---Icons",
  transform: "translate(-896.000000, -256.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "user-outline",
  transform: "translate(896.000000, 256.000000)"
}, /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle-Copy",
  x: 0,
  y: 0,
  width: 32,
  height: 32
}), /*#__PURE__*/React.createElement("g", {
  id: "icon32/user-outline"
}, /*#__PURE__*/React.createElement("mask", {
  id: "mask-2",
  fill: "white"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#path-1"
})), /*#__PURE__*/React.createElement("use", {
  id: "symbol",
  fill: "#1E445C",
  fillRule: "evenodd",
  xlinkHref: "#path-1"
})))));

var SvgUserOutline = function SvgUserOutline(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "32px",
    height: "32px",
    viewBox: "0 0 32 32",
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref3, _ref4);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgUserOutline, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/user-outline.b68d576f.svg";
export { ForwardRef as ReactComponent };